import { render, staticRenderFns } from "./orderPay.vue?vue&type=template&id=6488eb22&scoped=true&"
import script from "./orderPay.vue?vue&type=script&lang=js&"
export * from "./orderPay.vue?vue&type=script&lang=js&"
import style0 from "./orderPay.vue?vue&type=style&index=0&id=6488eb22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6488eb22",
  null
  
)

export default component.exports